import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNotebook from './notebook.reducer';

export const selectNotebookState = createFeatureSelector<fromNotebook.NotebookFeatureState>(
  fromNotebook.notebookFeatureKey
);

export const tokens = createSelector(selectNotebookState, (state) => state.tokens);
export const pusherChannelNames = createSelector(selectNotebookState, (state) => state.pusherChannelNames);
export const sessions = createSelector(selectNotebookState, (state) => state.sessions);
export const resources = createSelector(selectNotebookState, (state) => state.resources);
export const initialized = createSelector(selectNotebookState, (state) => state.initialized);
export const states = createSelector(selectNotebookState, (state) => state.states);
export const awaitingInitialRun = createSelector(selectNotebookState, (state) => state.awaitingInitialRun);
export const notebookTypes = createSelector(selectNotebookState, (state) => state.notebookTypes);
export const newCellTokensByNotebook = createSelector(selectNotebookState, (state) => state.cellTokensByNotebook);
export const selectImporting = createSelector(selectNotebookState, (state) => state.importing);
export const selectImportError = createSelector(selectNotebookState, (state) => state.importError);
